import React, { useState } from 'react'
import classNames from 'classnames'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { Form, Input, Button, message, notification } from 'antd'

import styles from '../style.module.scss'

import { API_URL } from '../../../../config/app'

const ForgotPasswordComponent = () => {
  const [btnLoading, handleBtnLoading] = useState(false)
  const [form] = Form.useForm()

  const onFinish = (values) => {
    handleBtnLoading(true)
    axios
      .post(`${API_URL}/api/v1/auth/reset-password`, { email: values.email })
      .then((res) => {
        if (res.data.success) {
          notification.success({ message: 'Success', description: 'Password reset link was sent to your email.' })
          form.resetFields()
        }
        handleBtnLoading(false)
      })
      .catch(() => {
        notification.error({ message: 'Error', description: 'Something goes wrong, try again please' })
        handleBtnLoading(false)
      })
  }

  const onFinishFailed = () => {
    message.error('Something goes wrong. Reload the page and try again please.')
  }

  const validateMessages = {
    required: 'This field is required!',
    types: {
      email: 'Enter an email address',
    },
  }

  return (
    <div>
      <div className={classNames('card', styles.auth_card)}>
        <h1 className={styles.auth_card__title}>Password Reset</h1>
        <p>Forgot your password? Enter your email below and we will send you instructions to reset it.</p>
        {/* begin auth form */}
        <Form
          form={form}
          layout="vertical"
          hideRequiredMark
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="mb-4"
          validateMessages={validateMessages}
        >
          <Form.Item
            name="email"
            hasFeedback
            rules={[{ required: true, message: 'Please input your e-mail address' }, { type: 'email' }]}
          >
            <Input size="large" placeholder="Email" />
          </Form.Item>
          <Button
            type="primary"
            size="large"
            className="text-center w-100 fw-600"
            htmlType="submit"
            loading={btnLoading}
          >
            Reset password
          </Button>
        </Form>
      </div>
      <div className="text-center mt-3 mb-auto">
        <Link to="/secured/login">Sign in</Link>
      </div>
    </div>
  )
}

export default ForgotPasswordComponent
